import { action, observable, makeAutoObservable } from "mobx"

import type { PagedResultDto } from "@services/dto/pagedResultDto"
import wfPriorityService from "@services/workflow/wfPriorityService"
import { initMultiLanguageField } from "@lib/helper"

class WfPriorityStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
  }
  @action
  async create(createWfPriorityInput) {
    this.isLoading = true
    await wfPriorityService
      .create(createWfPriorityInput)
      .finally(() => (this.isLoading = false))
  }

  @action
  async update(updateWfPriorityInput) {
    this.isLoading = false
    await wfPriorityService
      .update(updateWfPriorityInput)
      .finally(() => (this.isLoading = false))
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await wfPriorityService.activateOrDeactivate(id, isActive)
  }

  @action
  async get(id) {
    this.detailData = await wfPriorityService.get({ id })
  }

  @action
  async createWfPriority() {
    this.detailData = {
      id: 0,
      names: initMultiLanguageField(),
      isActive: true,
    }
  }

  @action
  async getAll(pagedFilterAndSortedRequest: any) {
    this.isLoading = true
    this.tableData = await wfPriorityService
      .filter(pagedFilterAndSortedRequest)
      .finally(() => (this.isLoading = false))
  }

  @action
  async updateSortList(ids: number[]) {
    await wfPriorityService.updateSortList(ids)
  }
}

export default WfPriorityStore
